import React from "react";
import "./ErrorPage.css";

export const ErrorPage = () => {
  return (
    <div className="advanced-404">
      <div className="left">
        <div className="glitch-text" data-text="404">
          404
        </div>
      </div>
      <div className="right">
        <h2 className="headline">Lost in the style maze?</h2>
        <p className="subtext">
          The page you're looking for doesn’t exist. But fashion never stops.
        </p>
        <a href="/" className="cta-btn">
          Go Back Home
        </a>
      </div>
    </div>
  );
};
